/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Search_ResultsInputs */

const en_no_search_results = /** @type {(inputs: No_Search_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No search results`)
};

const nl_no_search_results = /** @type {(inputs: No_Search_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen zoekresultaten`)
};

/**
* | output |
* | --- |
* | "No search results" |
*
* @param {No_Search_ResultsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_search_results = /** @type {((inputs?: No_Search_ResultsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Search_ResultsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_no_search_results(inputs)
	return en_no_search_results(inputs)
});